export default __webpack_public_path__ + "static/media/timeanalysis.3db2ae10.gif";